// extracted by mini-css-extract-plugin
export default {"pills":"DKWTDDEGrhB_Gq4cPBY0","rightShadow":"X2OVIuxUlmoCog0bzZWm","leftShadow":"AbANxM6rAnD4TMFq4WoA"};